<template>
  <v-container>
    <v-row justify="center" class="mt-8">
      <v-col cols="12" sm="10" md="8" lg="6">
        <v-card v-on:keyup.enter="submit()" ref="form">
          <v-card-text>
            <img
              class=" mx-auto d-block logo"
              :src="logo"
              alt="PinPoint Logo"
            />
            <span v-if="!isAuthenticated">
              <div class="d-flex align-center justify-center" v-if="errorText">
                <v-icon color="error">mdi-alert-circle</v-icon>
                <span class="text-subtitle-1 font-weight-medium ml-1">
                  {{ errorText }}
                </span>
              </div>
              <v-text-field
                :prepend-icon="svgAccountCircle"
                placeholder="User ID"
                :rules="[rules.required]"
                v-model="loginData.username"
              ></v-text-field>
              <v-text-field
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                :rules="[rules.required]"
                :type="show1 ? 'text' : 'password'"
                :prepend-icon="svgLock"
                placeholder="Password"
                hint="At least 8 characters"
                v-model="loginData.password"
              ></v-text-field>
              <div class="d-flex justify-space-between text-right mt-2">
                <span>
                  <router-link :to="{ name: 'Registration' }">
                    <v-btn outlined>Register</v-btn>
                  </router-link>
                  <h5 class="pt-2 pb-1">Not signed up yet?</h5>
                </span>
                <span>
                  <v-btn
                    @click="submit()"
                    color="primary"
                    :disabled="isDisabled"
                  >
                    Log in
                  </v-btn>
                  <h5 class="pt-2 pb-1">
                    <router-link :to="{ name: 'PasswordRecovery' }">
                      Forgot Password?
                    </router-link>
                  </h5>
                </span>
              </div>
            </span>
            <span v-if="isAuthenticated && loginDetails">
              <h1 class="ma-5 text-center">WELCOME, {{ getName }}!</h1>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiAccountCircle } from "@mdi/js";
import { mdiLock } from "@mdi/js";
import RadectLogo from "../../../assets/RadectHealthLogoLarge.svg";

export default {
  name: "Login",
  components: {},
  data: () => ({
    loginData: { username: "", password: "" },
    svgAccountCircle: mdiAccountCircle,
    svgLock: mdiLock,
    logo: RadectLogo,
    show1: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters"
    },
    errorText: ""
  }),
  created() {},
  updated() {
    if (this.isAuthenticated) {
      this.$router.push(
        { name: "Records" },
        onComplete => {},
        onAbort => {}
      );
    }
  },
  computed: {
    ...mapGetters({
      loginDetails: "getUser",
      isAuthenticated: "isAuthenticated",
      getToken: "getToken",
      getName: "getLoggedInName"
    }),
    isDisabled() {
      return !(this.loginData.username && this.loginData.password);
    }
  },
  methods: {
    async login() {
      this.loginData.axios = this.$axios;
      this.$store
        .dispatch("sendLoginData", this.loginData)
        .then()
        .catch(err => {
          this.errorText = err.response.data.non_field_errors.join(", ");
        });
    },
    async submit() {
      await this.login();
      //when update hooks runs looks for is authenticated and pushes to records
    }
  }
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}
.logo {
  max-height: 300px;
  max-width: 100%;
}
</style>
